module.exports = __webpack_public_path__ + "static/media/logos_50h_siemens.bd3a2d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_siemens.jpg
// module id = 225
// module chunks = 0